module.exports = __webpack_public_path__ + "img/DSC_7700.9ef64bda.jpg";